import { render, staticRenderFns } from "./userCatalogue.vue?vue&type=template&id=a45e0f0c&scoped=true"
import script from "./userCatalogue.vue?vue&type=script&lang=js"
export * from "./userCatalogue.vue?vue&type=script&lang=js"
import style0 from "./userCatalogue.vue?vue&type=style&index=0&id=a45e0f0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45e0f0c",
  null
  
)

export default component.exports